import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { DocsLayout } from "@app/layout/DocsLayout.tsx";
import { GuidePage } from "@app/pages/GuidePage.tsx";
import { HomePage } from "@app/pages/HomePage.tsx";
import { NotFoundPage } from "@app/pages/NotFoundPage.tsx";
import { OperationPage } from "@app/pages/OperationPage.tsx";
import { DEFAULT_VERSION, isKnownVersion } from "@lib/content.ts";

/** Rejects an unknown version before the layout tries to read its bundle. */
function VersionGuard({ children }: { children: React.ReactNode }) {
  const { version } = useParams();
  if (!isKnownVersion(version)) return <NotFoundPage />;
  return children;
}

export function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={`/${DEFAULT_VERSION}`} replace />}
      />

      <Route
        path="/:version"
        element={
          <VersionGuard>
            <DocsLayout />
          </VersionGuard>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="guides/:slug" element={<GuidePage />} />
        <Route path="reference/:operationId" element={<OperationPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
